export default __webpack_public_path__ + "static/media/icon_search.8d4dc3ec.svg";